import Vue from 'vue'
import {
  emailDaIndustria as routingEmailIndustria,
  email as routingEmail
} from '../util/routes'

export default {
  state: {
    email: {}
  },
  mutations: {
    setEmail: (state, payload) => {
      state.email = payload
    }
  },
  actions: {
    async getEmailDaIndustria ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routingEmail}/${id}`)
      commit('setEmail', data)
    },
    async postSaveEmailNaIndustria ({ state }, { key }) {
      const { email } = state
      if (email.id) {
        return Vue.axios.put(
          `${routingEmail}/${email.id}`,
          email
        )
      }
      return Vue.axios.post(
        `${routingEmailIndustria}`,
        email,
        {
          headers: {
            industria: key
          }
        }
      )
    },
    async deleteEmail ({ state }) {
      const { email } = state
      return Vue.axios.delete(`${routingEmail}/${email.id}`)
    }
  },
  getters: {
    email: ({ email }) => email
  }
}
